export default class BaseShaderNode {
  constructor() { }
  getDefines() { return ''; }
  getFunctions() { return ''; }
  getMainBody() { return ''; }
}



// WEBPACK FOOTER //
// ./src/lib/shaderGraph/BaseShaderNode.js